const hashGadgetIds = (ids: string[]): string => {
  let h = 0;
  for (const id of [...ids].sort()) {
    for (let i = 0; i < id.length; i++) {
      h = ((h << 5) - h + id.charCodeAt(i)) | 0;
    }
  }
  return h.toString(36);
};

export default hashGadgetIds;
